module.exports = __webpack_public_path__ + "img/hu.a5686df2.svg";